<template>
  <div class="font-montserrat">
    <h2>GM Actions</h2>
    <div>
      <ul class="nav nav-tabs">
        <li
          v-for="(action, idx) in gmActions"
          :key="action.name"
          class="nav-item"
        >
          <a
            class="nav-link"
            :class="{ active: idx === activeTab }"
            href="#"
            @click.prevent="activeTab = idx"
          >
            {{ action.name }}
          </a>
        </li>
      </ul>
      <div class="mt-3">
        <h4>{{ gmActions[activeTab].name }}</h4>
        <p>{{ gmActions[activeTab].description }}</p>
        <ul>
          <li
            v-for="param in gmActions[activeTab].parameters"
            :key="param.name"
          >
            <strong>{{ param.name }}</strong>
            <span> ({{ param.type }})</span>
            <span v-if="param.required"> - Required</span>
            <span v-else> - Optional</span>
            <span v-if="param.default">, Default: {{ param.default }}</span>
          </li>
        </ul>
        <!-- Input fields for parameters -->
        <form class="mt-3" @submit.prevent="executeAction">
          <div
            v-for="param in gmActions[activeTab].parameters"
            :key="param.name"
            class="mb-2"
          >
            <label :for="param.name">{{ param.name }}</label>
            <input
              v-if="param.type === 'string'"
              type="text"
              class="form-control"
              :id="param.name"
              v-model="formInputs[param.name]"
              :placeholder="param.default ? param.default : ''"
              :required="param.required"
            />
            <input
              v-else-if="param.type === 'number'"
              type="number"
              class="form-control"
              :id="param.name"
              v-model.number="formInputs[param.name]"
              :placeholder="param.default ? param.default : ''"
              :required="param.required"
            />
            <select
              v-else-if="param.type === 'boolean'"
              class="form-control"
              :id="param.name"
              v-model="formInputs[param.name]"
              :required="param.required"
            >
              <option :value="true">True</option>
              <option :value="false">False</option>
            </select>
          </div>
          <button type="submit" class="btn btn-primary mt-2">Execute</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const gmActions = ref([
  {
    name: "Teleport",
    description: "Teleport Player or GM to a specific location",
    parameters: [
      { name: "Player/GM Name", type: "string", required: true },
      { name: "Location", type: "string", required: true },
    ],
  },
  {
    name: "Spawn Mobs",
    description: "Spawn mobs in the game world",
    parameters: [
      { name: "Mob ID", type: "number", required: true },
      { name: "Quantity", type: "number", required: false, default: 1 },
      { name: "Location", type: "string", required: false },
    ],
  },
  {
    name: "GM Visibility Toggle",
    description: "Toggle GM visibility (visible/invisible) in the game world",
    parameters: [
      { name: "GM Name", type: "string", required: true },
      { name: "Visibility", type: "boolean", required: true, default: true },
    ],
  },
  {
    name: "Kick Player",
    description: "Remove a player from the game server",
    parameters: [{ name: "Player Name", type: "string", required: true }],
  },
  {
    name: "Ban Player",
    description: "Ban a player from the game server",
    parameters: [
      { name: "Player Name", type: "string", required: true },
      {
        name: "Duration (hours)",
        type: "number",
        required: false,
        default: 24,
      },
      { name: "Reason", type: "string", required: false },
    ],
  },
]);

const activeTab = ref(0);

// Form input state
const formInputs = ref({});

// Initialize formInputs when activeTab changes
const initFormInputs = () => {
  const params = gmActions.value[activeTab.value].parameters;
  formInputs.value = {};
  params.forEach((param) => {
    formInputs.value[param.name] =
      param.default !== undefined
        ? param.default
        : param.type === "boolean"
        ? false
        : "";
  });
};
watch(activeTab, initFormInputs, { immediate: true });

// Mock execute action
function executeAction() {
  const action = gmActions.value[activeTab.value];
  alert(
    `Executing "${action.name}"\nDescription: ${
      action.description
    }\nParameters: ${JSON.stringify(formInputs.value, null, 2)}`
  );
}
</script>

<style lang="scss" scoped></style>
